exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.quick_help_button {\r\n  text-decoration: none !important;\r\n  font-size: 16px !important;\n}\n.sb-table-top-actions .v-btn.quick_help_button {\r\n  padding-left: 8px;\r\n  padding-right: 8px;\n}\r\n", ""]);

// exports
